import {Component, OnInit} from "@angular/core";
import {Auth2Service} from "../../../services/auth2.service";
import {ApiService} from "../../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserService} from "../services/users.service";
import {HttpErrorResponse} from "@angular/common/http";
import {FundingGoalDto} from "../../../models/funding-goal-dto";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-funding-goals-management',
  templateUrl: './funding-goals-management.component.html',
  styleUrls: ['./funding-goals-management.component.scss'],
  standalone: false
})
export class FundingGoalsManagementComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Your Funding Goals', path: 'app/users/dashboard/funding-goals/all'},
    { label: 'Create / Edit Funding Goal'}
  ];
  savedFundingGoalId: number = -1;
  savedFundingGoalName: string = '';
  savedDueDate: string = '';
  savedFundingAmtNeeded: string = '0';
  savedFormattedFundingAmtNeeded = '0';
  savedDescription: string = '';
  savedCreatedTS: string = '';
  savedUpdatedTS: string = '';
  savedSearchFundingGoalMappings: any[] = [];

  savedSearchMappingsListTemp: any[] = [];

  pageTitle: string = 'Create / Edit Funding Goal';

  username: string = '';
  userId: number = -1;
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  readOnly: boolean = false;

  savedSearchList: any[] = [];

  currentSavedSearchDto: any = {};
  //Needs pop up for Funding Goal Limit on creation
  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private userService : UserService,
              private routerChild: Router, private route: ActivatedRoute, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Create or Edit Funding Goal");
  }

  ngOnInit() {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    const browserUrl: string = window.location.href;
    this.readOnly = this.apiService.calculateReadOnly(browserUrl, this.impersonatedEmail, this.consultantRoleName);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    // @ts-ignore
    this.userId = this.auth2ServiceChild.getUserId();
    //app/users/dashboard/funding-goals/:fundingGoalId/edit
    const fundingGoalId = this.route.snapshot.paramMap.get('fundingGoalId');
    if (!this.username) {
      this.routerChild.navigateByUrl('app/login');
    } else if (this.username && fundingGoalId &&
        (browserUrl.includes('funding-goals') && (browserUrl.includes('edit') || browserUrl.includes('view') )
      )) {
      this.titleService.setTitle("Scalanthropy Edit Funding Goal");
      if (browserUrl.includes('view')) {
        this.titleService.setTitle("Scalanthropy View Funding Goal");
        this.breadCrumbs[4] = { label: 'View Funding Goal'};
        this.pageTitle = 'View Funding Goal';
      }
      this.userService.getFundingGoal(parseInt(fundingGoalId), this.username, this.impersonatedEmail)
        .subscribe((result: any) => {
        if (result && result.body) {
          this.savedFundingGoalId = result.body.fundingGoalId;
          this.savedFundingGoalName = result.body.fundingGoalName;
          //this.savedDueDate
          let tempDateTimeString: string = '';
          tempDateTimeString = (new Date(result.body.fundingDueDate)).toLocaleString();
          let tempDateString: string = tempDateTimeString.split(',')[0];
          let tempDateStringArray: string[] = tempDateString.split('/');
          let monthString: string = this.apiService.formatMonth(tempDateStringArray[0]);
          let dayString: string = tempDateStringArray[1];
          let yearString : string = tempDateStringArray[2];
          const fundingDueDateEl = document.getElementById('due-date-text-id');
          //yyyy-MM-dd
          this.savedDueDate = yearString + '-' + monthString + '-' + dayString;
          // @ts-ignore
          fundingDueDateEl.value = this.savedDueDate;
          this.savedFundingAmtNeeded = result.body.fundingAmtNeeded;
          const fundingAmtNeededEl = document.getElementById('funding-amount-needed-text-id');
          // @ts-ignore
          fundingAmtNeededEl.value = this.savedFundingAmtNeeded;
          this.formatMoneyOnChange()
          this.savedDescription = result.body.fundingGoalDescr;
          this.savedCreatedTS = (new Date(result.body.createdTS)).toLocaleString();
          this.savedUpdatedTS = (new Date(result.body.updatedTS)).toLocaleString();

          //load all the saved searches
          this.userService.getAllSavedSearchesOverview(this.username).subscribe(
            (result3: any) => {
              if (result3 && result3.body) {
                this.savedSearchList = result3.body;
              }
            }, (err: HttpErrorResponse) => {
              this.redirectToLogin(err);
              this.pageErrorMessages.push({
                field: 'Saved Search API Error',
                detail: 'Failed to download the savedSearches',
                severity: 'error'
              });
              this.showPageErrorMessagesToUser();
            }
          );

          //load the saved search funding goals mapping
          this.userService.getAllFundingGoalSavedSearchMappingsByFundingGoalId(this.username, fundingGoalId,
            this.impersonatedEmail).subscribe((result2: any) => {
            if (result2 && result2.body) {
              this.savedSearchFundingGoalMappings = result2.body;
            }
          }, (err: HttpErrorResponse) => {
            this.redirectToLogin(err);
            this.pageErrorMessages.push({
              field: 'Saved Search API Error',
              detail: 'Failed to download the savedSearches mapped to funding goals...',
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
          });
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Saved Search API Error',
          detail: 'Failed to download the savedSearches mapped to funding goals...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      });
    } else if (this.username &&
      browserUrl.includes('funding-goals') && browserUrl.includes('create')) {
      this.titleService.setTitle("Scalanthropy Create Funding Goal");
      //load all the saved searches
      this.userService.getAllSavedSearchesOverview(this.username).subscribe(
        (result3: any) => {
          if (result3 && result3.body) {
            this.savedSearchList = result3.body;
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Saved Search API Error',
            detail: 'Failed to pull  the saved searches...',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    }
  }

  validate(s: string): boolean {
    let rgx: RegExp = new RegExp(/^[0-9]*\.?[0-9]*$/);
    return rgx.test(s);
  }

  //onkeypress='return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)'

  formatMoneyOnChange() : void {
    let fundingAmtEl = document.getElementById('funding-amount-needed-text-id')
    // @ts-ignore
    let fundingAmtRawVal: string =  fundingAmtEl.value;
    if (!fundingAmtRawVal) {
      // @ts-ignore
      fundingAmtEl.value = fundingAmtRawVal;
      return
    }
    if (fundingAmtRawVal.length <= 3) {
      return
    }

    fundingAmtRawVal = fundingAmtRawVal.replace(/[^0-9]/,'')
    fundingAmtRawVal = fundingAmtRawVal.replace(/^0+/,'')
    // @ts-ignore
    fundingAmtEl.value = this.formatMoneyWithCommas(fundingAmtRawVal);
  }

  formatMoneyWithCommas(rawMoneyVal: string): string {
    let moneyAmtArray: string[] = [];
    let moneyAmtIntText: string = '';
    let moneyAmtFloatText: string = '00';
    if (rawMoneyVal) {
      let regExp : RegExp = new RegExp('\.')
      if (regExp.test(rawMoneyVal)) {
        moneyAmtArray = rawMoneyVal.split('\.');
        moneyAmtIntText = moneyAmtArray[0];
        moneyAmtFloatText = moneyAmtArray[1];
      } else {
        moneyAmtIntText = rawMoneyVal
      }
    } else {
      moneyAmtIntText = rawMoneyVal
    }
    moneyAmtIntText = moneyAmtIntText.replaceAll(',','')
    let formattedMoneyText = ''
    let length =  moneyAmtIntText.length;
    let count = 0;
    let i = length - 1
    while ( i >= 0 ) {
      if (count == 3) {
        count = 0;
        formattedMoneyText = formattedMoneyText + ',';
      }
      formattedMoneyText = formattedMoneyText + moneyAmtIntText[i];
      count++;
      i = i - 1
    }
    if (',' == (formattedMoneyText.charAt(formattedMoneyText.length - 1))) {
      formattedMoneyText = formattedMoneyText.substring(0, formattedMoneyText.length - 1);
    }

    let formattedMoneyTextFinal: string = '';
    let j = formattedMoneyText.length - 1;
    while ( j >= 0 ) {
      formattedMoneyTextFinal = formattedMoneyTextFinal + formattedMoneyText[j]
      j = j - 1;
    }
    return formattedMoneyTextFinal;
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/all');
  }

  onSave(): void {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    const fundingGoalNameEl = document.getElementById('funding-goal-name-text-id');
    // @ts-ignore
    this.savedFundingGoalName = fundingGoalNameEl.value;
    if (!this.savedFundingGoalName || this.savedFundingGoalName.length > 50) {
      this.pageErrorMessages.push({
        field: 'Funding Goal Name Error',
        detail: 'The Funding Goal Name is required and must not exceed 50 characters.',
        severity: 'error'
      });
    }
    this.savedDueDate = '';
    const fundingDueDateEl = document.getElementById('due-date-text-id');
    // @ts-ignore
    this.savedDueDate = fundingDueDateEl.value;
    if (!this.savedDueDate) {
      this.pageErrorMessages.push({
        field: 'Funding Due Date Error',
        detail: 'The Funding Due Date is required',
        severity: 'error'
      });
    }
    this.savedDueDate = this.savedDueDate + 'T00:00'
    const fundingAmtNeededEl = document.getElementById('funding-amount-needed-text-id');
    // @ts-ignore
    //this.savedFundingAmtNeeded = fundingAmtNeededEl.value;
    console.log(this.savedFundingAmtNeeded);
    // @ts-ignore
    const tempFundingVal: string = fundingAmtNeededEl.value;
    this.savedFundingAmtNeeded = tempFundingVal.replaceAll(',','')
    console.log('tempFundingVal: ' + tempFundingVal);
    try {
      let tempFundingTest: number = parseInt(this.savedFundingAmtNeeded);
      console.log('tempFundingTest: ' + tempFundingTest)
      if (!this.savedFundingAmtNeeded || tempFundingTest <= 0 || tempFundingTest <= 0.0) {
        this.pageErrorMessages.push({
          field: 'Funding Amount Error',
          detail: 'The Funding Amount is required and must be greater than $0.00.',
          severity: 'error'
        });
      }
    } catch (e) {
      this.pageErrorMessages.push({
        field: 'Funding Amount Error',
        detail: 'You must enter a valid integer.',
        severity: 'error'
      });
    }

    const fundingGoalDescrEl = document.getElementById('funding-goal-description-id');
    // @ts-ignore
    this.savedDescription = fundingGoalDescrEl.value;
    console.log('onSave() this.savedDescription: ' + this.savedDescription);
    if (!this.savedDescription || this.savedDescription.length > 500) {
      this.pageErrorMessages.push({
        field: 'Description Error',
        detail: 'The Description is required and must not exceed 500 characters.',
        severity: 'error'
      });
    }

    // @ts-ignore
    const userIdStr = localStorage.getItem('userId');
    // @ts-ignore
    const userId: number = parseInt(userIdStr);

    if (this.pageErrorMessages.length > 0) {
      this.showPageErrorMessagesToUser();
      return;
    }
    this.savedFundingGoalName = this.apiService.removeControlChar(this.savedFundingGoalName);
    this.savedDescription = this.apiService.escapeOutput(this.savedDescription);

    if (this.savedFundingGoalId == -1) {
      // @ts-ignore
      const fundingGoalDto: FundingGoalDto= {
        fundingGoalId: this.savedFundingGoalId,
        userId: userId,
        fundingGoalName: this.savedFundingGoalName,
        fundingDueDate: this.savedDueDate,
        fundingAmtNeeded: parseInt(this.savedFundingAmtNeeded),
        fundingGoalDescr: this.savedDescription,
        createdTS: '',
        updatedTS: ''
      }
      // @ts-ignore
      this.userService.addNewFundingGoal(fundingGoalDto, this.username,
        this.impersonatedEmail).subscribe((result: any) => {
          if (result && result.body) {
            this.savedFundingGoalId = result.body.fundingGoalId
            //Update the saved search mappings
            //Compile a list of existing saved search mappings
            let toBeSubmittedSavedSearchMappingList: any[] = [];
            for (const savedSearchMappingTemp of this.savedSearchFundingGoalMappings) {
              toBeSubmittedSavedSearchMappingList.push(
                {
                  savedSearchFundingGoalMappingId: savedSearchMappingTemp.savedSearchFundingGoalMappingId,
                  savedSearchId: savedSearchMappingTemp.savedSearchId,
                  fundingGoalId: this.savedFundingGoalId,
                  userId: savedSearchMappingTemp.userId
                }
              );
            }
            //Merge with a list possibly saved search mappings
            this.userService.updateSavedSearchFundingGoalsMapping(this.savedFundingGoalId.toString(), this.username,
              toBeSubmittedSavedSearchMappingList, this.impersonatedEmail).subscribe((result4: any) => {
                if (result4 && result4.body) {
                  //for debugging
                }
              this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/all')
            }, (err: HttpErrorResponse) => {
              this.redirectToLogin(err);
              this.pageErrorMessages.push({
                field: 'Failed Saved Search Funding Goal Mapping Error',
                detail: 'Failed to Saved Search Funding Goal Mapping...',
                severity: 'error'
              });
              this.showPageErrorMessagesToUser();
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          if (err.error && err.error.limitReached == "Y"
            && err.error.currentAmount == err.error.limitAmount) {
            this.pageErrorMessages.push({
              field: 'Funding Goal Limit Reached',
              detail: 'Woah, woah! You have reached your limit of ' + err.error.limitAmount +' funding goals. Consider deleting some funding goals, especially older ones.',
              severity: 'error'
            });
          } else {
            this.pageErrorMessages.push({
              field: 'Add New Funding Goal Error',
              detail: 'Failed to Add New Funding Goal...',
              severity: 'error'
            });
          }

          this.showPageErrorMessagesToUser();
        });
    } else {
      // @ts-ignore
      const fundingGoalDto: FundingGoalDto= {
        fundingGoalId: this.savedFundingGoalId,
        userId: userId,
        fundingGoalName: this.savedFundingGoalName,
        fundingDueDate: this.savedDueDate,
        fundingAmtNeeded: parseInt(this.savedFundingAmtNeeded),
        fundingGoalDescr: this.savedDescription,
        createdTS: '',
        updatedTS: ''
      };
      // @ts-ignore
      this.userService.editFundingGoal(fundingGoalDto, this.username, this.impersonatedEmail).subscribe((result: any) => {
          if (result && result.body) {
            //Update the saved search mappings
            //Update the saved search mappings
            //Compile a list of existing saved search mappings
            let toBeSubmittedSavedSearchMappingList: any[] = [];
            for (const savedSearchMappingTemp of this.savedSearchFundingGoalMappings) {
              toBeSubmittedSavedSearchMappingList.push(
                {
                  savedSearchFundingGoalMappingId: savedSearchMappingTemp.savedSearchFundingGoalMappingId,
                  savedSearchId: savedSearchMappingTemp.savedSearchId,
                  fundingGoalId: savedSearchMappingTemp.fundingGoalId,
                  userId: savedSearchMappingTemp.userId
                }
              );
            }


            //Merge with a list possibly saved search mappings
            this.userService.updateSavedSearchFundingGoalsMapping(this.savedFundingGoalId.toString(), this.username,
              toBeSubmittedSavedSearchMappingList, this.impersonatedEmail).subscribe((result4: any) => {
              if (result4 && result4.body) {
                //for debugging
              }
              this.routerChild.navigateByUrl('app/users/dashboard/funding-goals/all')
            }, (err: HttpErrorResponse) => {
              this.redirectToLogin(err);
              this.pageErrorMessages.push({
                field: 'Failed Saved Search Funding Goal Mapping Error',
                detail: 'Failed to Saved Search Funding Goal Mapping...',
                severity: 'error'
              });
              this.showPageErrorMessagesToUser();
            });
          }
        },
        (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Failed Saved Edited Funding Goal Error',
            detail: 'Failed to Saved Edited Funding Goal Error.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        });
    }
  }

  /**
   * Deletes the savedsearch mapping locally, only upon submission does it save the deletion
   * @param savedSearchFundingGoalMapping
   */
  onDeleteSavedSearchFundingGoalMapping(savedSearchFundingGoalMapping: any): void {
    let tempList: any[] = [];
    for (const savedSearchFundingGoalMappingTemp of this.savedSearchFundingGoalMappings) {
      if (savedSearchFundingGoalMappingTemp.savedSearchName != savedSearchFundingGoalMapping.savedSearchName) {
        tempList.push(savedSearchFundingGoalMappingTemp);
      }
    }
    this.savedSearchFundingGoalMappings = tempList;
    return;
  }

  openInNewTab(route: string) {
    const url = this.routerChild.serializeUrl(
      this.routerChild.createUrlTree([route])
    );
    window.open(url, '_blank');
  }

  /**
   *
   * @param savedSearchFundingGoalMapping
   */
  onApplySavedSearch(savedSearchFundingGoalMapping: any) : void {
    this.userService.getSavedSearch(savedSearchFundingGoalMapping.savedSearchId, this.username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.currentSavedSearchDto = result.body;
          let expirationTimestamp: number = Date.now() + 1000*3600*2;
          if (this.currentSavedSearchDto.searchTypeDto.searchTypeName == 'DONOR_SEARCH') {
            localStorage.setItem('lastSearchDonorExpTime', expirationTimestamp.toString());
            localStorage.setItem('lastSearchDonor', this.currentSavedSearchDto.savedSearchJson);
            this.openInNewTab('app/search/donors')
            return;
          } else if (this.currentSavedSearchDto.searchTypeDto.searchTypeName == 'GRANT_SEARCH') {
            localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
            localStorage.setItem('lastSearchGrant', this.currentSavedSearchDto.savedSearchJson);
            this.openInNewTab('app/search/grants')
            return;
          } else if (this.currentSavedSearchDto.searchTypeDto.searchTypeName == 'NONPROFIT_SEARCH') {
            localStorage.setItem('lastSearchNonprofitExpTime', expirationTimestamp.toString());
            localStorage.setItem('lastSearchNonprofit', this.currentSavedSearchDto.savedSearchJson);
            this.openInNewTab('app/search/nonprofits')
            return;
          } else {
            this.pageErrorMessages.push({
              field: 'Unknown Search Type Error',
              detail: 'Unknown Search Type: ' + this.currentSavedSearchDto.searchTypeDto.searchTypeName,
              severity: 'error'
            });
            this.showPageErrorMessagesToUser();
          }
        }
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Saved Search API Error',
          detail: 'Failed to download the savedSearchId: ' + this.currentSavedSearchDto.savedSearchId,
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      }
    );
    return;
  }

  onAddSavedSearchMapping(): void {
    const searchSavedSearchDropdownEl = document.getElementById('saved-searches-dropdown-list-id');
    // @ts-ignore
    let searchSavedSearchDropdownVal = searchSavedSearchDropdownEl.value;
    if (searchSavedSearchDropdownVal) {
      let savedSearchIdTemp = -1;
      for (const savedSearchObj of this.savedSearchList) {
        if (savedSearchObj['savedSearchName'] == searchSavedSearchDropdownVal) {
          savedSearchIdTemp = savedSearchObj['savedSearchId'];
        }
      }
      const savedSearchFundingGoalMappingDto: any = {
        savedSearchFundingGoalMappingId: -1,
        savedSearchId: savedSearchIdTemp,
        savedSearchName: searchSavedSearchDropdownVal,
        fundingGoalId: this.savedFundingGoalId,
        userId: this.userId
      }
      //Check if savedSearchName is already in the this.savedSearchFundingGoalMappings
      let found: boolean = false;
      let size: number = this.savedSearchFundingGoalMappings.length;
      let i: number = 0;
      while (i < size) {
        if (this.savedSearchFundingGoalMappings[i]['savedSearchName'] == searchSavedSearchDropdownVal ) {
          found = true;
          break;
        }
        i = i + 1;
      }
      if (!found) {
        //Does not exist yet in the array
        this.savedSearchFundingGoalMappings.push(savedSearchFundingGoalMappingDto);
      }
    }
  }
}
